import { useEffect } from 'react';
// Helpers
import { getTokenFromCookies } from 'helpers/cookies';
import { AUTH_LOST_EVENT } from 'helpers/auth';
// Hooks
import { useAppContext } from 'hooks';

const CookieTokenWatcher = () => {
  const { token, setToken, clearGuestToken } = useAppContext();

  useEffect(() => {
    const intervalId = setInterval(() => {
      const cookieToken = getTokenFromCookies();

      if (!token && cookieToken) {
        clearGuestToken();
        setToken(cookieToken);
      }

      /**
       * Cookies disappeared while React still thinks we're logged in.
       * Previously we called `useLogout()`, which navigates to HOME and
       * defeats the in-place auth-lost modal. Dispatch the event so
       * AppContext can open the modal in place; if the user really did
       * log out elsewhere, the modal still surfaces a sensible state.
       */
      if (token && !cookieToken) {
        window.dispatchEvent(new CustomEvent(AUTH_LOST_EVENT));
      }

      if (token && cookieToken && token.id !== cookieToken.id) {
        setToken(cookieToken);
      }
    }, 2000);

    return () => {
      clearInterval(intervalId);
    };
  }, [token, setToken, clearGuestToken]);

  return null;
};

export default CookieTokenWatcher;
